export const currencyFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
});

export const compactCurrencyFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    notation: 'compact',
    maximumFractionDigits: 1
});

export const formatCurrency = (amount) => currencyFormatter.format(amount);

export const compactCurrency = (amount) => compactCurrencyFormatter.format(amount);

export const isBlank = (value) => value === null || value === undefined || value === '';

export const normalizeText = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const capitalizeFirstLetter = (value) => {
    const text = String(value ?? '');

    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const getDigits = (value) => String(value ?? '').replace(/\D/g, '');

export const CNPJ_DIGITS_LENGTH = 14;

export const CEP_DIGITS_LENGTH = 8;

export const isCnpjDocument = (value) => getDigits(value).length === CNPJ_DIGITS_LENGTH;

export const formatSnakeCaseLabel = (value) => String(value ?? '')
    .split('_')
    .map((part) => capitalizeFirstLetter(part))
    .join(' ');
